import { MessageAuthor } from '../../../structure';
import { CreateDecisions } from '../../types';

export const createMessageBubbleDecisions: CreateDecisions<MessageAuthor> = ({ decisions }) => ({
    backgroundColor: {
        value: decisions.backgroundColor.body.basic,
        variant: {
            user: {
                value: decisions.backgroundColor.semantic.primary,
            },
            team: {
                value: decisions.backgroundColor.semanticSubtleTransparent.primary,
            },
            other: {
                value: decisions.backgroundColor.surface.thin.default,
            },
        },
    },
    color: {
        value: decisions.textColor.semantic.basic,
        variant: {
            user: {
                value: decisions.textColor.onSemanticBackground.light,
            },
            team: {
                value: decisions.textColor.semantic.basic,
            },
            other: {
                value: decisions.textColor.semantic.basic,
            },
        },
    },
});
